import { useCallback, useEffect, useState } from 'react';

import { ISecaoLab } from '@/@types/Contato/Secoes';
import { api } from '@/services/api';
import { IUsuario } from '@/@types/Comunidade';
import { ContatoEnderecoFeagri } from '@/components/PagesComponents/Secoes/ContatoEnderecoFeagri';
import { DiretoriaSecaoComponent } from '@/components/PagesComponents/Secoes/DiretoriaComponent';


const ContatoDiretoria = () => {
    const [diretorSecaoData, setDiretorSecaoData] = useState<ISecaoLab>({} as ISecaoLab); //dados da seção de diretoria
    const [diretoriaAssociadaSecaoData, setDiretoriaAssociadaSecaoData] = useState<ISecaoLab>({} as ISecaoLab); //dados da seção de diretoria associada
    const [atuSecaoData, setAtuSecaoData] = useState<ISecaoLab>({} as ISecaoLab); // dados da seção de atu
    const [secretariaDirecaoSecaoData, setSecretariaDirecaoSecaoData] = useState<ISecaoLab>({} as ISecaoLab); // dados da seção de secretaria de diretoria

    const [diretorData, setDiretorData] = useState<IUsuario>({} as IUsuario); // dados do diretor
    const [diretoriaAssociadaData, setDiretoriaAssociadaData] = useState<IUsuario>({} as IUsuario); // dados da diretora associada

    const getDiretorData = useCallback(async () => {
        // função que busca os dados do diretor por matrícula
        const url = `/user/register/matricula/${diretorSecaoData.secoes_user_matricula}`;

        await api.get<IUsuario[]>(url)
            .then(({ data }) => {
                setDiretorData(data[0]);
            })
            .catch(err => {
                console.log(err);
            })
    }, [diretorSecaoData]);

    const getDiretoriaAssociadaData = useCallback(async () => {
        // função que busca os dados do diretor associado por matrícula
        const url = `/user/register/matricula/${diretoriaAssociadaSecaoData.secoes_user_matricula}`;

        await api.get<IUsuario[]>(url)
            .then(({ data }) => {
                setDiretoriaAssociadaData(data[0]);
            })
            .catch(err => {
                console.log(err);
            })
    }, [diretoriaAssociadaSecaoData]);

    useEffect(() => {
        getDiretorData();
    }, [getDiretorData, diretorSecaoData.secoes_user_matricula]);

    useEffect(() => {
        getDiretoriaAssociadaData();
    }, [getDiretoriaAssociadaData, diretoriaAssociadaSecaoData.secoes_user_matricula]);


    useEffect(() => {

        const getDiretorSecaoData = async () => {
            // busca os dados da seção do diretor
            const url = `/feagri/secaolabs/secoes_orgao/28.00.00.00.00`;

            await api.get<ISecaoLab[]>(url)
                .then(({ data }) => {
                    setDiretorSecaoData(data[0]);
                })
                .catch(err => {
                    console.log(err);
                });
        }

        const getDiretoriaAssociadaSecaoData = async () => {
            // busca os dados da seção da diretora associada
            const url = `/feagri/secaolabs/secoes_orgao/28.01.00.00.00`;

            await api.get<ISecaoLab[]>(url)
                .then(({ data }) => {
                    setDiretoriaAssociadaSecaoData(data[0]);
                })
                .catch(err => {
                    console.log(err);
                });
        }

        const getAtuSecaoData = async () => {
            // busca os dados da seção de atu
            const url = `/feagri/secaolabs/secoes_orgao/28.30.00.00.00`;

            await api.get<ISecaoLab[]>(url)
                .then(({ data }) => {
                    setAtuSecaoData(data[0]);
                })
                .catch(err => {
                    console.log(err);
                });
        }

        const getSecretariaDirecaoSecaoData = async () => {
            // busca os dados da seção de secretaria de diretoria
            const url = `/feagri/secaolabs/secoes_orgao/28.12.00.00.00`;

            await api.get<ISecaoLab[]>(url)
                .then(({ data }) => {
                    setSecretariaDirecaoSecaoData(data[0]);
                })
                .catch(err => {
                    console.log(err);
                });
        }

        getDiretorSecaoData();
        getDiretoriaAssociadaSecaoData();
        getAtuSecaoData();
        getSecretariaDirecaoSecaoData();

    }, []);

    return (
        <div className='md:flex md:justify-between'>

            <DiretoriaSecaoComponent
                atuSecaoData={atuSecaoData}
                diretorData={diretorData}
                diretorSecaoData={diretorSecaoData}
                diretoriaAssociadaData={diretoriaAssociadaData}
                diretoriaAssociadaSecaoData={diretoriaAssociadaSecaoData}
                secretariaDirecaoSecaoData={secretariaDirecaoSecaoData}
            />

            <ContatoEnderecoFeagri />
        </div>
    );
}

export { ContatoDiretoria };